import HttpClient from "./HttpClient";
export default class Tool{
    constructor(tool){
        this.id = tool.id;
        this.company_id = tool.company_id;
        this.code = tool.code;
        this.description = tool.description;
        this.length = tool.length;
        this.diameter = tool.diameter;
        this.geometry = tool.geometry;
    }

    static async loadTools(loadPage){
        const client = new HttpClient();
        const response = await client.instance.get("tools", {
            params: {
                page: loadPage
            }
        })
        const tools = [];
        response.data.data.forEach(tool => {
            tools.push(new Tool(tool));
        });
        const page = response.data.current_page;
        const pages = response.data.last_page;
        return { tools, page, pages }
    }

    static async create(data){
        try{
            const client = new HttpClient();
            const response = await client.instance.post("tools", data);
            return response.data;
        } catch(error){
            return false;
        }
    }

    async save(){
        try{
            const client = new HttpClient();
            const response = await client.instance.put(`tools/${this.id}`, this);
            return response.data;
        } catch(error){
            return false;
        }
    }
}